<template>
  <error404 />
</template>

<script>
import error404 from '~/components/ErrorPages/404.vue';

export default {
  name: 'NotFound',

  components: {
    error404
  }
};
</script>
